// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__Wo1WF","modal__close":"styles_modal__close__NTMKn","modal__label-tooltip":"styles_modal__label-tooltip__uD5A4"};